module.exports = __webpack_public_path__ + "img/logo-house-medium-7.e2fdbf07.svg";